module.exports = __webpack_public_path__ + "img/chat.d14667fc.png";